import styled from 'styled-components';
import { ActionButton } from '@fluentui/react/lib/Button';
import { DatePicker } from '@fluentui/react';
import { ChevronRightRegular, ChevronLeftRegular } from '@fluentui/react-icons';
import { Checkbox } from '@fluentui/react-components';

export const TimesheetsHeader = styled.div`
  height: 58px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${(props) =>
    props.theme.timesheetsHeaderBackground}; // Use props for theme access
  padding: 0 20px;

  @media (max-width: 480px) {
    height: auto;
    flex-wrap: wrap;
    justify-content: center;
  }
`;

export const DatePickerButton = styled(ActionButton)`
  span {
    color: ${(props) =>
      props.theme.timesheetsTableTextMainColor}; // Use props for theme access
    font-weight: 700;
    font-size: 1.125rem;
  }
`;

export const Datepicker = styled(DatePicker)`
  position: absolute;
  top: 10;
  width: 150px;

  #id {
    display: none;
  }

  .ms-Callout-main [class*='ms-slideDownIn'] [class*='root-'] {
    background-color: red;
  }
`;

export const ChevronRight = styled(ChevronRightRegular)`
  font-size: 25px;
`;

export const ChevronLeft = styled(ChevronLeftRegular)`
  font-size: 25px;
`;

export const DatePickerContainer = styled.div`
  display: flex;
  align-items: center;

  @media (min-width: 481px) {
    flex-grow: 1;
  }

  @media (max-width: 480px) {
    flex-wrap: wrap;
  }
`;

export const StyledCheckbox = styled(Checkbox)`
  white-space: nowrap;
  @media (min-width: 481px) {
    margin-left: auto;
  }
`;
